import { DarkTooltip } from 'components/Tooltips/CustomTooltips';
import HelpIcon from '@mui/icons-material/Help';
import { colors } from 'utilities';
import styles from './styles.module.scss';
import { useTranslates } from 'providers/translates';

export const MandatoryText: React.FC = () => {
  const { translates: t } = useTranslates();
  const tellUsAboutVeteran = t?.quiltBuilderStepOne?.tellUsAboutVeteran;

  return (
    <div className={styles.mandatoryText}>
      <p>
        <span className="requiredSymbol">*</span>{tellUsAboutVeteran?.thisFieldIsMandatoryText ?? 'Mandatory'}
      </p>
      <DarkTooltip
        title={
          <span>
            {tellUsAboutVeteran?.mandatoryPopup ?? (
              'First and last name, and years of birth and death are required so that your quilt can be found if published publicly.'
            )}
          </span>
        }
      >
        <HelpIcon sx={{ width: '20px', color: colors.blue }} />
      </DarkTooltip>
    </div>
  );
}
